import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { getTenantSchemaPlans } from '../api/tenantSchemaApi';
import { DataTable } from '../components/DataTable';
import { ErrorState } from '../components/ErrorState';
import { LoadingState } from '../components/LoadingState';
import { PageShell } from '../components/PageShell';
import { StatusBadge } from '../components/StatusBadge';

export function TenantSchemaPlansPage() {
  const { t } = useTranslation(['tenantSchema', 'common']);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTenantSchemaPlans({ per_page: 100 });
      setRows(response.data || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const columns = useMemo(() => [
    { id: 'tenant_id', label: t('tenantSchema:plans.columns.tenant'), render: (row) => <RouterLink to={`/tenants/${row.tenant_id}`}>{t('tenantSchema:dashboard.tenant_link', { id: row.tenant_id })}</RouterLink> },
    { id: 'status', label: t('common:status'), render: (row) => <StatusBadge status={row.status} category="schema_plan" /> },
    { id: 'mode', label: t('tenantSchema:plans.columns.mode') },
    { id: 'included_migrations_count', label: t('tenantSchema:plans.columns.included') },
    { id: 'excluded_migrations_count', label: t('tenantSchema:plans.columns.excluded') },
  ], [t]);

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={t('tenantSchema:plans.load_failed')} onRetry={load} />;

  return (
    <PageShell title={t('tenantSchema:plans.title')} subtitle={t('tenantSchema:plans.subtitle')}>
      <DataTable columns={columns} rows={rows} rowKey="id" emptyMessage={t('tenantSchema:plans.no_plans')} />
    </PageShell>
  );
}
